"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import { ErrorPage, Page } from "@sitecore-content-sdk/nextjs";
import client from "lib/sitecore-client";
import scConfig from "sitecore.config";
import Providers from "src/Providers";
import Layout from "src/Layout";
import { capitalizeLanguageRegion } from "lib/utils";
import SiteConsentProvider from "lib/consent/SiteConsentProvider";

export default function GlobalError() {
  const [page, setPage] = useState<Page | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadErrorPage() {
      try {
        const page = await client.getErrorPage(ErrorPage.InternalServerError, {
          site: scConfig.defaultSite,
          locale: capitalizeLanguageRegion(scConfig.defaultLanguage),
        });
        setPage(page);
      } catch {
        setPage(null);
      }

      setLoading(false);
    }

    loadErrorPage();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (page) {
    // global-error replaces the root layout when it renders, so it inherits no provider
    // from app/[site]/[locale]/layout.tsx and must supply its own - Layout renders
    // <Scripts />, whose tracking components all gate on useConsent().
    return (
      <SiteConsentProvider>
        <Providers page={page}>
          <Layout page={page} />
        </Providers>
      </SiteConsentProvider>
    );
  }

  return (
    <div style={{ padding: 10 }}>
      <h1>500 Internal Server Error</h1>
      <p>
        There is a problem with the resource you are looking for, and it cannot
        be displayed.
      </p>
      <Link href="/">Go to the Home page</Link>
    </div>
  );
}
